rdefine('app/formular/components/frm/Placeholder',['backbone','text!formular/placeholder.html'],function(Backbone,placeholder){
    return Backbone.Ribs.View.extend({
        bindings:{
            '.placeholder':{
                text:'model.base.name'
            }
        },
        initialize:function() {
            this.$el.addClass("active");
            this.$el.addClass("form-placeholder");
            this.$el.html(placeholder);
        }
    })
});